<script setup lang="ts">
import { DateTime } from 'luxon'
import { DatePickerProps } from 'primevue/datepicker'
import { computed, ComputedRef } from 'vue'

type BaseProps = Omit<DatePickerProps, 'modelValue' | 'onUpdate:modelValue'>

const props = withDefaults(defineProps<BaseProps>(), {
    // TODO: HAve to manually set defaults which seems very fragile but will work for now
    //modelValue: null,
    //defaultValue: null,
    //name: null,
    selectionMode: 'single',
    //dateFormat: null,
    inline: false,
    showOtherMonths: true,
    selectOtherMonths: false,
    showIcon: false,
    iconDisplay: 'button',
    //icon: null,
    //prevIcon: null,
    //nextIcon: null,
    //incrementIcon: null,
    //decrementIcon: null,
    numberOfMonths: 1,
    //responsiveOptions: null,
    breakpoint: '769px',
    view: 'date',
    //minDate: null,
    //maxDate: null,
    //disabledDates: null,
    //disabledDays: null,
    //maxDateCount: null,
    showOnFocus: true,
    autoZIndex: true,
    baseZIndex: 0,
    showButtonBar: false,
    shortYearCutoff: '+10',
    showTime: false,
    timeOnly: false,
    hourFormat: '24',
    stepHour: 1,
    stepMinute: 1,
    stepSecond: 1,
    showSeconds: false,
    hideOnDateTimeSelect: false,
    hideOnRangeSelection: false,
    timeSeparator: ':',
    showWeek: false,
    manualInput: true,
    //size: null,
    invalid: false,
    disabled: false,
    variant: 'outlined',
    readonly: false,
    //placeholder: null,
    appendTo: 'body',
    //id: null,
    //inputId: null,
    //inputStyle: null,
    //inputClass: null,
    //panelStyle: null,
    //panelClass: null,
    //todayButtonProps: null,
    //clearButtonProps: null,
    //navigatorButtonProps: null,
    //timepickerButtonProps: null,
    //fluid: null,
    //ariaLabelledby: null,
    //ariaLabel: null,
    //formControl: null,
    dt: null,
    //pt: null,
    //ptOptions: null,
    unstyled: false,
})

const selected = defineModel<null | DateTime | DateTime[] | (null | DateTime)[]>('selected', { required: true })

const internalSelected: ComputedRef<null | Date | Date[] | (null | Date)[]> = computed(() => {
    if (!selected.value || (Array.isArray(selected.value) && selected.value.length === 0)) {
        return props.selectionMode === 'single' ? null : []
    }

    if (Array.isArray(selected.value)) {
        return selected.value.map((date) => date !== null ? date.toJSDate() : null)
    }

    console.log('val', selected.value?.zoneName)
    return selected.value.toJSDate()
})

// TODO: There's an issue with our selection logic because the internal date classes aren't taking the timezone from the datetimes
// TODO: Remove unneeded logging
const updateInternalSelected = (value: null | Date | Date[] | (null | Date)[] | undefined) => {
    console.log('updateInternalSelected')

    if (Array.isArray(value)) {
        selected.value = value.map((date) => date !== null ? DateTime.fromJSDate(date) : null)
    } else {
        selected.value = value ? DateTime.fromJSDate(value) : null
    }
}

const valueInternalChange = (value: null | Date | Date[] | (null | Date)[] | undefined) => {
    console.log('valueInternalChange')

    updateInternalSelected(value)
}

const hourFormat = computed(() => {
    const locale = DateTime.local().locale
    const format = new Intl.DateTimeFormat(locale, { hour: 'numeric'})

    return format.resolvedOptions().hour12 ? '12' : '24'
})
</script>

<template>
  <DatePicker
    v-bind="props"
    :hour-format="hourFormat"
    :model-value="internalSelected"
    @update:model-value="updateInternalSelected"
    @value-change="valueInternalChange"
  >
    <template
      v-for="(_, name) in $slots"
      #[name]="slotData"
    >
      <slot
        :name="name"
        v-bind="slotData"
      />
    </template>
  </DatePicker>
</template>
